export default {
  realm: process.env.VUE_APP_KEYCLOAK_REALM || "sigeam",
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT || "admin-cli",
  url:
    process.env.VUE_APP_KEYCLOAK_SERVER_URL ||
    "https://idm-homologacao.prodam.am.gov.br/auth",
};
